import { CheckSquareOutlined, CheckSquareTwoTone } from '@ant-design/icons'
import { DatePicker, Form, Modal, Select, Input, message } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { contract_master_listing, create_fuel_tank_event, fuel_tank_master, fuel_tank_master_unique, get_fuel_tank_event, update_fuel_tank_event } from '../../Services/fuel management'

const TankEventModal = ({ mode, open, close, setRelaoder }) => {

    let [form] = Form.useForm()
    const [error, setError] = useState(false)
    const [dropdowns, setDropdowns] = useState({
        vendor: [],
        fuel_tank: [],
        service_tank: []
    })
    const [invoiceInputs, setInvoiceInputs] = useState({
        invoice_total: undefined,
        fuel_subtotal: undefined,
        fees_subtotal: undefined,
        gallons_added: undefined
    })
    let InputContainer = ({ label, children }) => {
        return <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span className="label">{label}</span>
            {children}
        </div>
    }

    const fetchVendor = async () => {
        let response = await contract_master_listing()
        if (response?.httpStatus === 200) setDropdowns(prev => { return { ...prev, vendor: response?.data?.map(x => { return { value: x?.id, label: x?.Company } }) } })
    }

    const fetchFuelTank = async () => {
        let response = await fuel_tank_master_unique()
        if (response?.httpStatus === 200) setDropdowns(prev => { return { ...prev, service_tank: response?.data?.map(x => { return { value: x?.SrvcGalType, label: x?.SrvcGalType } }) } })
    }

    const fetchServiceTank = async (value) => {
        if (value) {
            let response = await fuel_tank_master({ SrvcGalType: value })
            if (response?.httpStatus === 200) setDropdowns(prev => { return { ...prev, fuel_tank: response?.data?.map(x => { return { value: x?.id, label: x?.FTName } }) } })
        }
    }

    const show_invoice_amt_reconcile = () => {
        if ([undefined, 0, ""]?.includes(invoiceInputs?.invoice_total)) return <CheckSquareOutlined />
        if (Number(invoiceInputs?.invoice_total) === (Number(invoiceInputs?.fees_subtotal) + Number(invoiceInputs?.fuel_subtotal))) return <CheckSquareTwoTone twoToneColor="#52c41a" />
        else return <CheckSquareOutlined />
    }

    const show_gross_ppg = () => {
        let gross_ppg = invoiceInputs?.invoice_total / invoiceInputs?.gallons_added;
        if ([undefined, 0, "", "0", NaN, Infinity]?.includes(gross_ppg)) return <span style={{ fontSize: "14px" }}>0</span>
        else return <span style={{ fontSize: "14px", fontWeight: "600" }}>{gross_ppg % 1 === 0 ? gross_ppg : gross_ppg.toFixed(4).slice(0, -1)}</span>
    }

    const show_fees_subtotal = (type) => {
        let fuel_cost = invoiceInputs?.invoice_total - invoiceInputs?.fuel_subtotal;
        let map = {
            modal: {
                zero: <span style={{ fontSize: "14px" }}>0</span>,
                show: <span style={{ fontSize: "14px", fontWeight: "600" }}>{fuel_cost % 1 === 0 ? fuel_cost : fuel_cost.toFixed(4).slice(0, -1)}</span>
            },
            payload: {
                zero: 0,
                show: fuel_cost % 1 === 0 ? fuel_cost : fuel_cost.toFixed(4).slice(0, -1)
            }
        }
        if ([undefined, 0, "", '', "0", NaN, Infinity]?.includes(fuel_cost)) return map[type]?.zero
        else return map[type]?.show
    }

    const show_gross_ppg_for_payload = () => {
        let gross_ppg = invoiceInputs?.invoice_total / invoiceInputs?.gallons_added;
        if ([undefined, 0, "", "0", NaN, Infinity]?.includes(gross_ppg)) return 0
        else return gross_ppg % 1 === 0 ? gross_ppg : gross_ppg.toFixed(4).slice(0, -1)
    }

    const fetchEvent = async () => {
        let response = await get_fuel_tank_event(mode)
        if (response?.httpStatus === 200) {
            fetchServiceTank(response?.data?.FuelTankMaster?.SrvcGalType)
            form.setFieldsValue({
                FillDate: response?.data?.FillDate ? moment(response?.data?.FillDate)?.utc() : null,
                FuelTkID: response?.data?.FuelTkID,
                ContractorId: response?.data?.ContractorId,
                BOL: response?.data?.BOL,
                PO: response?.data?.PO,
                SrvcGallonType: response?.data?.FuelTankMaster?.SrvcGalType,
                Gallons: response?.data?.Gallons,
                InvNbr: response?.data?.InvNbr,
                InvTotalAmt: response?.data?.InvTotalAmt,
                InvFuelSub: response?.data?.InvFuelSub,
                InvFeeSub: response?.data?.InvFeeSub
            })
            setInvoiceInputs({
                invoice_total: response?.data?.InvTotalAmt || undefined,
                fuel_subtotal: response?.data?.InvFuelSub || undefined,
                fees_subtotal: response?.data?.InvFeeSub || undefined,
                gallons_added: response?.data?.Gallons || undefined,
            })
        }
    }

    useEffect(() => {
        if (open) {
            fetchVendor()
            fetchFuelTank()
        }
        if (mode) {
            fetchEvent()
        } else {
            form.resetFields();
            setInvoiceInputs({
                invoice_total: undefined,
                fuel_subtotal: undefined,
                fees_subtotal: undefined,
                gallons_added: undefined,
            })
            // form.setFieldsValue({
            //     FuelTkID: 1
            // })
        }

    }, [open])


    const onSubmit = async (values) => {
        if (!invoiceInputs?.gallons_added || invoiceInputs?.gallons_added === "") return setError(true)

        let body = {
            ...values,
            PO: values?.PO ? +values?.PO : undefined,
            FillDate: values?.FillDate ? moment(values?.FillDate)?.format("YYYY-MM-DD") : undefined,
            InvNbr: values?.InvNbr || "0", // Set to null if empty
            InvFeeSub: show_fees_subtotal("payload"),
            InvFuelSub: invoiceInputs?.fuel_subtotal ? +invoiceInputs?.fuel_subtotal : 0,
            InvTotalAmt: values?.InvTotalAmt ? +values?.InvTotalAmt : 0,
            GrossPPG: show_gross_ppg_for_payload(),
            Gallons: invoiceInputs?.gallons_added ? +invoiceInputs?.gallons_added : undefined,
        }

        delete body.SrvcGallonType

        // Object.keys(body).forEach((key) => {
        //     if (!body[key] || body[key] == "")
        //         delete body[key]
        // })

        if (mode) {
            let response = await update_fuel_tank_event(mode, body)
            if (response?.httpStatus === 200) {
                message?.success("Fuel Tank Event Updated!")
                close()
                form.resetFields()
                setInvoiceInputs({
                    invoice_total: undefined,
                    fuel_subtotal: undefined,
                    fees_subtotal: undefined,
                    gallons_added: undefined,
                })
                setRelaoder(prev => prev = !prev)
            }
        }
        else {
            let response = await create_fuel_tank_event(body)
            if (response?.httpStatus === 200) {
                message?.success("Fuel Tank Event Added!")
                close()
                form.resetFields()
                setInvoiceInputs({
                    invoice_total: undefined,
                    fuel_subtotal: undefined,
                    fees_subtotal: undefined
                })
                setRelaoder(prev => prev = !prev)
            }
        }
    }

    return (
        <Modal
            open={open}
            onCancel={() => {
                close()
                form.resetFields()
                setInvoiceInputs({
                    invoice_total: undefined,
                    fuel_subtotal: undefined,
                    fees_subtotal: undefined,
                    gallons_added: undefined
                })
            }}
            footer={null}
            title="Add Fuel Tank Event"
            style={{
                top: "20px"
            }}
        >
            <Form
                form={form}
                onFinish={onSubmit}
                onFinishFailed={err => console.log(err)}
                onValuesChange={(changedValues, allValues) => {
                    if (changedValues?.SrvcGallonType) form.setFieldsValue({ FuelTkID: undefined })
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="label">{"Tank Fill Date"}</span>
                            <Form.Item name="FillDate" style={{ margin: "0" }} rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please select fill date!</span> }]}>
                                <DatePicker
                                    style={{ width: "194px" }}
                                    format="MM-DD-YYYY"
                                    disabledDate={current => current && current.isAfter(moment())}
                                />
                            </Form.Item>
                        </div>
                        <InputContainer label={"Service Gallon Type"}>
                            <Form.Item name="SrvcGallonType" style={{ margin: "0" }} rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please select service gallon type!</span> }]}>
                                <Select
                                    allowClear={false}
                                    showSearch
                                    options={dropdowns?.service_tank}
                                    onChange={fetchServiceTank}
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    style={{ width: "194px" }}
                                />
                            </Form.Item>
                        </InputContainer>

                        <InputContainer label={"Service Tank"}>
                            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.SrvcGallonType !== currentValues.SrvcGallonType} >
                                {({ getFieldValue }) =>
                                    <Form.Item name="FuelTkID" style={{ margin: "0" }} rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please select service tank!</span> }]}>
                                        <Select
                                            allowClear={false}
                                            showSearch
                                            options={dropdowns?.fuel_tank}
                                            disabled={!getFieldValue("SrvcGallonType")}
                                            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                            style={{ width: "194px" }}
                                        />
                                    </Form.Item>
                                }
                            </Form.Item>
                        </InputContainer>
                        <InputContainer label={"Vendor"}>
                            <Form.Item name="ContractorId" style={{ margin: "0" }} rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please select vendor!</span> }]}>
                                <Select
                                    allowClear
                                    showSearch
                                    options={dropdowns?.vendor}
                                    filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                                    style={{ width: "194px" }}
                                />
                            </Form.Item>
                        </InputContainer>
                        <InputContainer label={"Bill of lading"}>
                            <Form.Item name="BOL" style={{ margin: "0" }} rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please enter bill of lading!</span> }]}>
                                <Input maxLength={250} />
                            </Form.Item>
                        </InputContainer>
                        <InputContainer label={"PO#"}>
                            <Form.Item
                                name="PO"
                                style={{ margin: "0" }}
                                rules={[{ required: true, message: <span style={{ fontSize: "10px" }}>Please enter PO number!</span> }]}
                            >
                                <Input
                                    type="text"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onPaste={(event) => {
                                        const pastedData = event.clipboardData.getData('Text');
                                        if (!/^\d+$/.test(pastedData)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </Form.Item>
                        </InputContainer>


                        <Form.Item
                            name="Gallons"
                            style={{ margin: "0" }}
                            rules={[
                                {
                                    required: true,
                                    message: <span style={{ fontSize: "10px", color: "red", marginLeft: '278px', width: '100%' }}>Please enter gallons added!</span>,
                                },

                            ]}
                        >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <span className="label">{"Gallons Added"}</span>
                                <Input
                                    type="text"
                                    style={{ width: "195px" }}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onPaste={(event) => {
                                        const pastedData = event.clipboardData.getData('Text');
                                        if (!/^\d+$/.test(pastedData) || Number(pastedData) > 8000) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onChange={e => {
                                        const value = e.target.value;
                                        if (Number(value) <= 8000) {
                                            setInvoiceInputs(prev => ({ ...prev, gallons_added: value }));
                                        }
                                    }}
                                    value={invoiceInputs?.gallons_added}

                                />
                            </div>
                        </Form.Item>
                        <p style={{ fontSize: '9px', color: 'gray' }}>Gallons cannot be greater than 8000 </p>


                    </div>


                    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                        <span style={{ fontSize: "15px", fontWeight: 600 }}>Invoice Details</span>
                        <InputContainer label={"Invoice Nbr"}>
                            <Form.Item name="InvNbr" style={{ margin: "0" }}>
                                <Input
                                    type="text"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onPaste={(event) => {
                                        const pastedData = event.clipboardData.getData('Text');
                                        if (!/^\d+$/.test(pastedData)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </Form.Item>
                        </InputContainer>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="label">{"Invoice Total"}</span>
                            <Form.Item name="InvTotalAmt" style={{ margin: "0" }}>
                                <Input
                                    type="text"
                                    onKeyPress={(event) => {
                                        const key = event.key;
                                        if (!/[0-9.]/.test(key) || (key === '.' && event.currentTarget.value.includes('.'))) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onPaste={(event) => {
                                        const pastedData = event.clipboardData.getData('Text');
                                        if (!/^\d*\.?\d*$/.test(pastedData)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    value={invoiceInputs?.invoice_total}
                                    onChange={e => {
                                        const newInvoiceTotal = e.target.value;
                                        setInvoiceInputs(prev => {
                                            if (prev?.fuel_subtotal && Number(prev.fuel_subtotal) > Number(newInvoiceTotal)) {
                                                return { ...prev, invoice_total: newInvoiceTotal, fuel_subtotal: "" };
                                            }
                                            return { ...prev, invoice_total: newInvoiceTotal };
                                        });
                                    }}

                                />
                            </Form.Item>
                        </div>
                        <p style={{ fontSize: '9px', color: 'gray' }}>Please enter the invoice total before entering Fuel Sub.</p>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <span className="label">{"Fuel Sub Total"}</span>

                            <Input
                                style={{ width: "195px" }}
                                type="text"
                                disabled={!invoiceInputs?.invoice_total}
                                onKeyPress={(event) => {
                                    const key = event.key;

                                    if (!invoiceInputs?.invoice_total || !/[0-9.]/.test(key) || (key === '.' && event.currentTarget.value.includes('.'))) {
                                        event.preventDefault();
                                    }
                                }}
                                onPaste={(event) => {
                                    const pastedData = event.clipboardData.getData('Text');
                                    if (!/^\d*\.?\d*$/.test(pastedData)) {
                                        event.preventDefault();
                                    }
                                }}

                                value={invoiceInputs?.fuel_subtotal}
                                onChange={e => {
                                    const fuelSubtotalValue = e.target.value;


                                    if (fuelSubtotalValue === "") {
                                        setInvoiceInputs(prev => ({ ...prev, fuel_subtotal: "" }));
                                        return;
                                    }
                                    const num1 = Number(e.target.value);
                                    const num2 = Number(invoiceInputs?.invoice_total);

                                    console.warn(`num1 and num2 = ${num1 <= num2}`);
                                    console.warn(`num1 and num2 = ${num1} ${num2}`);
                                    if (num2 >= num1) {
                                        setInvoiceInputs(prev => ({ ...prev, fuel_subtotal: fuelSubtotalValue }));
                                    } else {
                                        e.preventDefault();
                                        setInvoiceInputs(prev => ({ ...prev, fuel_subtotal: '' }));
                                    }
                                }}
                            />

                        </div>
                        <span style={{ fontSize: '9px', color: 'gray' }}>{"Fuel Sub cannot be greater than the Invoice total"}</span>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                <span style={{ fontSize: "14px" }}>Gross PPG</span>
                                {show_gross_ppg()}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                                <span style={{ fontSize: "14px" }}>Fuel Fees</span>
                                {show_fees_subtotal("modal")}
                            </div>

                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button
                            type='submit'
                            style={{ background: "#2863AD", color: "white", borderRadius: "8px", border: "none", width: "200px", height: "50px", cursor: "pointer" }}>
                            Submit
                        </button>
                    </div>
                </div>
            </Form>

        </Modal>
    )
}

export default TankEventModal